import React from 'react';
import { MainLayout, Triptych } from '@app/components';
import { useResourceScreenHelpers } from '@app/hooks';
import { organizationApi } from '@app/store';
import { IOrganization } from '@tickeat/types';
import { SettingHeader } from '@app/features/SettingHeader';
import { OrganizationUpdate } from '@app/features/Organization';

export const OrganizationScreen = () => {
  const { data: organization, isFetching } = organizationApi.useReadOneOrganizationsQuery({});

  const { selectedItem } = useResourceScreenHelpers<IOrganization>();

  return (
    <MainLayout
      header={<SettingHeader />}>
      <Triptych
        form={(
          <OrganizationUpdate
            organization={organization ?? selectedItem}
            isFetching={isFetching} />
        )} />
    </MainLayout>
  );
};
